(() => {
  'use strict';

  // 顶部提示条轮播: fade 切换 + 鼠标拖拽/触摸滑动 + 自动轮播(悬停暂停)。
  // 单条信息时完全不初始化(纯静态展示)。
  const init = (scope = document) => {
    scope.querySelectorAll('[data-simple-notice]').forEach((root) => {
      if (root.dataset.simpleNoticeReady === 'true') return;
      root.dataset.simpleNoticeReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-simple-notice-slides] > .simple-notice-bar__slide'));
      if (slides.length < 2) return;

      let index = 0;
      let timer = null;
      let dragged = false;

      const go = (next) => {
        index = ((next % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      };
      const next = () => go(index + 1);
      const prev = () => go(index - 1);

      // 拖拽/滑动切换(鼠标和触摸统一走 Pointer Events)
      let startX = null;
      root.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        dragged = false;
      });
      root.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        startX = null;
        if (Math.abs(dx) < 30) return;   // 位移太小当作点击, 不切换
        dragged = true;
        dx < 0 ? next() : prev();
      });
      root.addEventListener('pointercancel', () => { startX = null; });

      // 拖拽后吞掉紧随的 click, 防止误触链接跳转
      root.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      }, true);

      // 自动轮播, 鼠标悬停暂停
      const autoplay = Number(root.dataset.autoplay) || 0;
      if (autoplay > 0) {
        const start = () => { if (!timer) timer = window.setInterval(next, autoplay); };
        const stop = () => { window.clearInterval(timer); timer = null; };
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        start();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
